import React, { Component } from 'react';
import { Col, Collapse } from 'reactstrap';
import './ContactCard.css';

export class ContactCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
        isOpen: false
    };
  }

  toggleDescription(delay) {
    if(typeof delay !== undefined) {
        setTimeout(() => this.setState({ isOpen: !this.state.isOpen }), delay);
    } else {
        this.setState({ isOpen: !this.state.isOpen });
    }
  }

  render() {
    let additionalClasses = (this.props.additionalClasses ? this.props.additionalClasses : '');
    return (
        <Col xl={4} md={4} sm={6} xs={12} className={`${additionalClasses}`}>
            <div className={'founder-card d-flex flex-column align-items-center text-center'} onMouseEnter={this.toggleDescription.bind(this)} onMouseLeave={this.toggleDescription.bind(this, 100)}>
                <img src={this.props.imagePath} style={{ width : '50%' }} className={'rounded-circle'} />
                <h5 className={'mt-3'}>{this.props.name}</h5>
                <h6>{this.props.role}</h6>
                <h6>{this.props.location}</h6>
                <Collapse isOpen={!this.state.isOpen}>
                    <span hidden={this.state.isOpen}>Learn more about me here</span>
                </Collapse>
                <Collapse isOpen={this.state.isOpen}>
                    <div className={'founder-card-description'}>
                        <p>
                            {this.props.description}
                        </p>
                    </div>
                </Collapse>
            </div>
        </Col>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/cards/ContactCard.js